// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-templates-folder-redirect-jsx": () => import("./../../../src/templates/FolderRedirect.jsx" /* webpackChunkName: "component---src-templates-folder-redirect-jsx" */),
  "component---src-templates-generic-jsx": () => import("./../../../src/templates/Generic.jsx" /* webpackChunkName: "component---src-templates-generic-jsx" */),
  "component---src-templates-i-18-n-redirect-jsx": () => import("./../../../src/templates/I18nRedirect.jsx" /* webpackChunkName: "component---src-templates-i-18-n-redirect-jsx" */)
}

